<template>
  <div>
    <div class="recordBox comStyBox">
      <yNavBar :title="urlData.courseName" />
      <div class="player-box">
        <PlayerCom :url="urlData.courseVod"></PlayerCom>
      </div>
      <div class="content-box">
        <div class="title">课程名：{{ urlData.courseName }}</div>
        <div class="content">{{ urlData.courseDesp }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import PlayerCom from "@/components/PlayerCom.vue";
export default {
  data() {
    return {
      title: "",
      urlData: this.$route.params.data,
      infocontent: "",
    };
  },
  mounted() {
    console.log(this.urlData);
    this.init();
  },

  methods: {
    init() {},
  },
  components: { PlayerCom },
  computed: {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
/deep/.content-wrapper {
  font-size: 16px;
}
.recordBox {
  width: 100%;
  box-sizing: border-box;
  min-height: 100vh;
  background-color: rgb(246, 246, 246);
  overflow: hidden;
}
.contentbox {
  padding: 6px;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  border-radius: 15px;
  background-color: #fff;
}
.content-box {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
  }
  .content {
    font-size: 14px;
    margin-top: 15px;
  }
}
</style>
